import { Reveal, RoseMark } from "./common";
import { IMAGES } from "../data/content";

const POINTS = [
  {
    n: "01",
    title: "Nel cuore di Galatina",
    text: "La Basilica sorge nel centro storico della città salentina, tra le strade che conservano l'impianto antico del borgo.",
  },
  {
    n: "02",
    title: "Un capolavoro del Salento",
    text: "È considerata uno dei più importanti monumenti artistici del Salento, dichiarata monumento nazionale nel 1870.",
  },
  {
    n: "03",
    title: "Romanico e gotico insieme",
    text: "L'edificio unisce la solidità del romanico pugliese allo slancio del gotico angioino, in una combinazione rara e originale.",
  },
  {
    n: "04",
    title: "Un cielo di affreschi",
    text: "L'interno è celebre per il vastissimo ciclo di affreschi del Quattrocento che ricopre volte, pareti e archi.",
  },
];

export const Intro = () => (
  <section className="relative grain bg-ivory py-24 sm:py-32 overflow-hidden">
    <RoseMark className="absolute -top-10 -right-10 w-64 h-64 text-gold/10 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
      <div className="lg:sticky lg:top-28">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="diamond" aria-hidden="true" />
            <span className="font-mono text-xs sm:text-sm tracking-[0.25em] uppercase text-gold">
              Benvenuti
            </span>
          </div>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-espresso tracking-tight leading-tight">
            Una chiesa che si legge
            <br />
            come un <em className="text-gold not-italic">libro di pietra</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 text-base sm:text-lg text-taupe leading-relaxed max-w-lg">
            A Galatina, a pochi chilometri da Lecce, si trova una delle chiese
            più sorprendenti dell'Italia meridionale. Questo sito la racconta
            come un progetto di divulgazione storico-artistica: la sua storia,
            la sua architettura, i suoi affreschi e le sue testimonianze, con
            il rigore delle fonti e la cura di chi l'arte la studia e la ama.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="img-frame mt-10 aspect-[4/3] hidden lg:block">
            <img
              src={IMAGES.pietraLeccese}
              alt="Dettaglio di una facciata in pietra leccese illuminata dal sole caldo"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-ink/10" />
          </div>
        </Reveal>
      </div>

      <div className="flex flex-col divide-y divide-stone">
        {POINTS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.08} className="group py-8 first:pt-0">
            <div className="flex items-start gap-6">
              <span className="font-serif text-4xl sm:text-5xl font-semibold text-gold/50 group-hover:text-gold transition-colors duration-500 leading-none">
                {p.n}
              </span>
              <div>
                <h3 className="font-serif text-xl sm:text-2xl font-semibold text-espresso">
                  {p.title}
                </h3>
                <p className="mt-2 text-base text-taupe leading-relaxed">{p.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
